import { DndProvider } from "react-dnd"
import "./status.css"
import { HTML5Backend } from "react-dnd-html5-backend"
import Topbar from "../../components/topbar/Topbar"

export default function Status({ socketio, connectionState, selectedMission, isMissionDragging }) {
  return (
    <>
    <DndProvider backend={HTML5Backend}>
        <Topbar connectionState={connectionState} selectedMission={selectedMission} isMissionDragging={isMissionDragging}/>
        <div className="mainContainer">
            <div className="status">
                <div className="statusWrapper">
                    Status
                </div>
            </div>
        </div>
    </DndProvider>
    </>
  )
}
